export const CellImage = ({ cell }) => {
    if (cell.column.id == "asset"
        || cell.column.id == "seize_token"
        || cell.column.id == "repay_token") {
        let srcStr = "assets/images/" + cell.value.toLowerCase() + ".png";
        return (
            <img src={srcStr} width="25" height="25" alt='' />
        )
    }
}

export const getActionColor = ({ cell }) => {
    if (cell.column.id == "action") {
        if (cell.value == 'supply' || cell.value == 'repay') {
            return "green";
        } else
            return "red";
    }
    else
        return 'black';
}

export const getBackgroundColor = ( value ) => {
    if (value >= 10000) {
        return "Cornsilk";
    }
}


export const getFontWeight = ({ cell }) => {
    if (cell.column.id == "action"
        || cell.column.id == "usdvalue" || cell.column.id == "seize_usdvalue") {
        return "bold";
    }
    else
return 'normal';
}

export const roundCoinAmount = (coinAmount) => {
    if (coinAmount > 1000)
        return Number(coinAmount.toFixed(0));
    else if (coinAmount > 10)
        return Number(coinAmount.toFixed(2));
    else
        return Number(coinAmount.toFixed(5));
}